/** Convert a wall-clock input in the tenant's IANA timezone without guessing the browser's timezone. */
export function inquiryDateTime(
  value: string,
  timezone: string
): string | undefined {
  if (!value) return undefined;
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value))
    throw new Error('Enter a complete date and time.');
  const [year, month, day, hour, minute] = value.split(/[-T:]/).map(Number);
  const wall = Date.UTC(year, month - 1, day, hour, minute);
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  });
  const wallAt = (instant: number) => {
    const parts = formatter.formatToParts(new Date(instant));
    const field = (name: string) =>
      Number(parts.find((part) => part.type === name)?.value);
    return Date.UTC(
      field('year'),
      field('month') - 1,
      field('day'),
      field('hour'),
      field('minute')
    );
  };
  let instant = wall;
  for (let attempt = 0; attempt < 4; attempt++)
    instant += wall - wallAt(instant);
  if (wallAt(instant) !== wall)
    throw new Error(
      'That local time does not exist because of a daylight-saving change. Choose a different time.'
    );
  if (wallAt(instant - 3600000) === wall || wallAt(instant + 3600000) === wall)
    throw new Error(
      'That local time occurs twice because of a daylight-saving change. Please contact the booking team to specify the time.'
    );
  return new Date(instant).toISOString();
}

export function inquiryWallTime(
  iso: string | undefined,
  timezone: string
): string {
  if (!iso) return '';
  const parts = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hourCycle: 'h23',
  }).formatToParts(new Date(iso));
  const field = (name: string) =>
    parts.find((part) => part.type === name)?.value;
  return `${field('year')}-${field('month')}-${field('day')}T${field(
    'hour'
  )}:${field('minute')}`;
}
